import { render } from "./CurtainFeedbackBoxItem.vue?vue&type=template&id=1908fe51"
import script from "./CurtainFeedbackBoxItem.vue?vue&type=script&lang=js"
export * from "./CurtainFeedbackBoxItem.vue?vue&type=script&lang=js"
script.render = render

export default script